// Where a team's clock-on QR sends a phone that scans it with the camera
// rather than with Dataphyll Crew: the QR is a link to /crewapp?x=..., and
// this page forwards the phone to its app store. The Crew app reads the
// payload itself and never opens the link.
//
// index.html carries the same two links in a small inline script, so a phone
// leaves before the app bundle loads; crewApp.test.ts holds them equal.

// Provisional until the store listings exist: Play uses the Android
// applicationId; the App Store link needs the listing's /id number.
export const CREW_PLAY_URL ='https://play.google.com/store/apps/details?id=com.dataphyll.crew_app'
export const CREW_APP_STORE_URL = 'https://apps.apple.com/nz/app/dataphyll-crew/'

export type CrewStore = 'android' | 'ios' | null

// An iPad asks for the desktop site and reports itself as a Mac, so a Mac
// with a touch screen counts as iOS.
export function crewStoreFor(userAgent: string, maxTouchPoints = 0): CrewStore {
  if (/Android/i.test(userAgent)) return 'android'
  if (/iPhone|iPad|iPod/.test(userAgent) || (/Macintosh/.test(userAgent) && maxTouchPoints > 1)) return 'ios'
  return null
}

// Until the App Store listing is live, an iPhone gets Crew in Safari
// (pages/CrewWebPage.tsx), keeping the scanned QR's query.
export const CREW_WEB_PATH = '/crew'

export const crewStoreUrl = (store: CrewStore, search = '') =>
  store === 'android' ? CREW_PLAY_URL : store === 'ios' ? CREW_WEB_PATH + search : null
